module.exports = __webpack_public_path__ + "static/1csm_pesacke_zone_sema-96ecbb48d4578592996e5900f59d8119.jpg";